import * as ngCore from '@angular/core'
import * as router from '@attain-apps/fe/web/main/lib/router'
import * as store from '@attain-apps/fe/web/main/lib/store'

import * as assistants from '../../../assistants'
import * as display from '../../../display'
import * as me from '../../../me'
import * as variableOverrides from '../../../variable-overrides'
import * as aliases from '../../aliases'
import { FEATURE } from '../feature'

import { getActionsConfig } from './actions'
import { ApiService } from './api.service'
import * as effects from './effects'
import { Selectors } from './selectors'
import { State } from './state'
import * as subfeatures from './subfeatures'

/** TODO: Explain what is this */
@ngCore.Injectable()
export class Feature extends store.Feature<
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  /** @see {@link ApiService} */
  public readonly api = ngCore.inject(ApiService)

  /** @see {@link subfeatures} */
  public readonly subfeatures

  constructor() {
    const meFeature = ngCore.inject(me.Feature)
    const toasterFeature = ngCore.inject(display.toaster.Feature)
    const variablesFeature = ngCore.inject(variableOverrides.Feature)
    const aliasesFeature = ngCore.inject(aliases.Feature)
    const routerFeature = ngCore.inject(router.Router)
    const assistantsFeature = ngCore.inject(assistants.Assistants)

    super({
      actions: getActionsConfig(),
      initialState: State.INITIAL,
      name: 'CurrentRendering',
      parent: FEATURE,
      selectors: () => new Selectors(this, meFeature, routerFeature),
    })

    const actionsFeature = new subfeatures.actions.Feature(
      this,
      meFeature,
      toasterFeature,
      routerFeature,
      variablesFeature,
      assistantsFeature,
    )
    const widgetsFeature = new subfeatures.widgets.Feature(
      this,
      actionsFeature,
      variablesFeature,
      aliasesFeature,
    )
    const modalFeature = new subfeatures.modal.Feature(
      this,
      widgetsFeature,
      variablesFeature,
      aliasesFeature,
    )
    const slideoutFeature = new subfeatures.slideout.Feature(
      this,
      widgetsFeature,
      variablesFeature,
      aliasesFeature,
    )
    const segmentsFeature = new subfeatures.segments.Feature(
      this,
      routerFeature,
    )

    const pageFeature = new subfeatures.page.Feature(this)

    this.subfeatures = {
      actions: actionsFeature,
      modal: modalFeature,
      page: pageFeature,
      segments: segmentsFeature,
      slideout: slideoutFeature,
      widgets: widgetsFeature,
    }

    this.registerEffects(
      // TODO: why does order matter here?
      effects.getRenderOnRequest(),
      effects.triggerPageRendering(variablesFeature),
      effects.setContext(),
      effects.putPageVariableDefinitions(variablesFeature),
    )
  }
}
